export default __webpack_public_path__ + "static/media/list_main_5_2.573ea1c0.png";